export const FETCH_HOME_DATA_START = "FETCH_HOME_DATA_START";
export const FETCH_HOME_DATA_SUCCESS = "FETCH_HOME_DATA_SUCCESS";
export const FETCH_HOME_DATA_FAIL = "FETCH_HOME_DATA_FAIL";

export const FETCH_MASTER_DATA_START = "FETCH_MASTER_DATA_START";
export const FETCH_MASTER_DATA_SUCCESS = "FETCH_MASTER_DATA_SUCCESS";
export const FETCH_MASTER_DATA_FAIL = "FETCH_MASTER_DATA_FAIL";

export const FETCH_CLOCK_INFO_START = "FETCH_CLOCK_INFO_START";
export const FETCH_CLOCK_INFO_SUCCESS = "FETCH_CLOCK_INFO_SUCCESS";
export const FETCH_CLOCK_INFO_FAIL = "FETCH_CLOCK_INFO_FAIL";

export const FETCH_TRIAGE_CLOCK_INFO_START = "FETCH_TRIAGE_CLOCK_INFO_START";
export const FETCH_TRIAGE_CLOCK_INFO_SUCCESS = "FETCH_TRIAGE_CLOCK_INFO_SUCCESS";
export const FETCH_TRIAGE_CLOCK_INFO_FAIL = "FETCH_TRIAGE_CLOCK_INFO_FAIL";

export const FETCH_CLOCK_LOG_START = "FETCH_CLOCK_LOG_START";
export const FETCH_CLOCK_LOG_SUCCESS = "FETCH_CLOCK_LOG_SUCCESS";
export const FETCH_CLOCK_LOG_FAIL = "FETCH_CLOCK_LOG_FAIL";

export const FETCH_TRIAGE_CLOCK_LOG_START = "FETCH_TRIAGE_CLOCK_LOG_START";
export const FETCH_TRIAGE_CLOCK_LOG_SUCCESS = "FETCH_TRIAGE_CLOCK_LOG_SUCCESS";
export const FETCH_TRIAGE_CLOCK_LOG_FAIL = "FETCH_TRIAGE_CLOCK_LOG_FAIL";

export const FETCH_CLOCK_PREV_LOG_START = "FETCH_CLOCK_PREV_LOG_START";
export const FETCH_CLOCK_PREV_LOG_SUCCESS = "FETCH_CLOCK_PREV_LOG_SUCCESS";
export const FETCH_CLOCK_PREV_LOG_FAIL = "FETCH_CLOCK_PREV_LOG_FAIL";

export const FETCH_TRIAGE_CLOCK_PREV_LOG_START = "FETCH_TRIAGE_CLOCK_PREV_LOG_START";
export const FETCH_TRIAGE_CLOCK_PREV_LOG_SUCCESS = "FETCH_TRIAGE_CLOCK_PREV_LOG_SUCCESS";
export const FETCH_TRIAGE_CLOCK_PREV_LOG_FAIL = "FETCH_TRIAGE_CLOCK_PREV_LOG_FAIL";

export const FETCH_CLOCK_DETAIL_INFO_START = "FETCH_CLOCK_DETAIL_INFO_START";
export const FETCH_CLOCK_DETAIL_INFO_SUCCESS = "FETCH_CLOCK_DETAIL_INFO_SUCCESS";
export const FETCH_CLOCK_DETAIL_INFO_FAIL = "FETCH_CLOCK_DETAIL_INFO_FAIL";

export const FETCH_EMAILD_LIST_SUCCESS = "FETCH_EMAILD_LIST_SUCCESS";
export const FETCH_EMAILD_LIST_FAILURE = "FETCH_EMAILD_LIST_FAILURE";
export const FETCH_EMAILD_LIST_START = "FETCH_EMAILD_LIST_START";

export const FETCH_REPORTS_MONTHLY_START = "FETCH_REPORTS_MONTHLY_START";
export const FETCH_REPORTS_MONTHLY_SUCCESS = "FETCH_REPORTS_MONTHLY_SUCCESS";
export const FETCH_REPORTS_MONTHLY_FAIL = "FETCH_REPORTS_MONTHLY_FAIL";

export const FETCH_REPORTS_BUFFER_START = "FETCH_REPORTS_BUFFER_START";
export const FETCH_REPORTS_BUFFER_SUCCESS = "FETCH_REPORTS_BUFFER_SUCCESS";
export const FETCH_REPORTS_BUFFER_FAIL = "FETCH_REPORTS_BUFFER_FAIL";
